import React from 'react';

export function withIframeProps(WrappedComponent) {
    const resizeObserver = new ResizeObserver(entries => {
        window.parent.postMessage(
            JSON.stringify({
                name: 'iframe-height-changed',
                height: Array.from(entries)[0].target.clientHeight
            }),
            '*'
        );
    });

    return class extends React.Component {
        static displayName = `withIframeProps(${
            WrappedComponent.displayName || WrappedComponent.name
        })`;

        componentDidMount() {
            resizeObserver.observe(document.body.querySelector('#content-wrapper > div'));
        }

        componentWillUnmount() {
            resizeObserver.disconnect();
        }

        render() {
            return <WrappedComponent {...this.props} {...(window.xprops || {})} />;
        }
    }
}



// WEBPACK FOOTER //
// ./with_iframe_props.js